export default __webpack_public_path__ + "static/mar-int-campaign-efd519d1a297b1be91cc33355117e915.png";